<div class="slider" [class.range]="range()" [style.width]="width()">
  <div class="slider-track">
    <div class="slider-fill" [style.width.%]="fillWidth()"></div>
    <div
      class="slider-handle"
      [style.left.%]="handlePosition()"
      (mousedown)="onMouseDown($event)"
      tabindex="0"
      (keydown)="onKeyDown($event)"
    ></div>
    @if (range()) {
      <div
        class="slider-handle end"
        [style.left.%]="endHandlePosition()"
        (mousedown)="onEndMouseDown($event)"
        tabindex="0"
      ></div>
    }
  </div>
</div>
